import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/help',
        name: 'help-home',
        component: () => import('@/pages/help/HelpIndex.vue'),
        children: [
            {
                path: '/help/:articleId',
                name: 'help-show',
                component: () => import('@/components/help/HelpArticle.vue'),
                props: true,
                meta: {
                    title: 'Help',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'help' },
                },
            },
        ],
    },
];
